import { push } from "connected-react-router";
import React, { useState } from "react";
import TopNavigationBar from "../../TopNavigationBar";
import { useDispatch, useSelector } from "react-redux";
import { VALIDATION_ERROR, VALIDATION_TYPE } from "../../../app/errors";

import { ValidateString, GetProviceCodeFromName } from "../../../app/utils";
import { ROUTE_PATH, APPLICATION_MODE_NEW, LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION } from "../../../app/constants";
import {
  Button,
  Header,
  Paragraph,
} from "../../../components/RegularComponents";
import AgentContactDetailsInputForm from "../../../components/ContactDetails/AgentContactDetailsInputForm";
import { setCurrentAgentPersonDetails } from "../../../redux/slice/additionalApplicationsSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { currentAgentApplicationSelector } from "../../../redux/selector/collectorApplicationSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";

export const AssociateBrokerAddApplicant = (props) => {
  const dispatch = useDispatch();

  const { isModal = false, onEditSave = () => {} } = props;

  const applicationMode = APPLICATION_MODE_NEW;
  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);

  // Agent here - need personData
  const personData = agentApplication?.businessLicenceData?.personData ?? {};

  const [showValidationError, setShowValidationError] = useState(false);

  // const viewMode = props.viewMode ?
  //         props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR)
  // const [viewMode,setViewMode] = useState(viewM)

  let defaultCollectorDetails = {
    firstName: personData.firstName || "",
    lastName: personData.lastName || "",
    phoneNumber: personData.phoneNumber || "",
    email: personData.email || "",
    addressData: {
      address1: personData?.addressData?.address1 || "",
      cityName: personData?.addressData?.cityName || "",
      stateName: personData?.addressData?.stateName || "",
      postalCode: personData?.addressData?.postalCode || "",
    },
  };

  const [updatedCollecorDetails, setUpdatedCollectorDetails] = useState(
    defaultCollectorDetails
  );

  const validateData = () => {
    //updatedCollecorDetails
    if (
      ValidateString(updatedCollecorDetails.firstName, VALIDATION_TYPE.NAME) !==
      VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (
      ValidateString(updatedCollecorDetails.lastName, VALIDATION_TYPE.NAME) !==
      VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (
      ValidateString(
        updatedCollecorDetails.phoneNumber,
        VALIDATION_TYPE.PHONE_NUMBER
      ) !== VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (
      ValidateString(updatedCollecorDetails.email, VALIDATION_TYPE.EMAIL) !==
      VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (!updatedCollecorDetails.addressData) return false;
    else if (
      ValidateString(
        updatedCollecorDetails.addressData.address1,
        VALIDATION_TYPE.STRING_NON_EMPTY
      ) !== VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (
      ValidateString(
        updatedCollecorDetails.addressData.cityName,
        VALIDATION_TYPE.STRING_NON_EMPTY
      ) !== VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (
      ValidateString(
        updatedCollecorDetails.addressData.stateName,
        VALIDATION_TYPE.STRING_NON_EMPTY
      ) !== VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (
      ValidateString(
        GetProviceCodeFromName(updatedCollecorDetails.addressData.stateName),
        VALIDATION_TYPE.CANADA_PROVINCE_CODE
      ) !== VALIDATION_ERROR.NO_ERROR
    )
      return false;
    else if (
      ValidateString(
        updatedCollecorDetails.addressData.postalCode,
        VALIDATION_TYPE.CANADA_POSTAL_CODE
      ) !== VALIDATION_ERROR.NO_ERROR
    )
      return false;

    return true;
  };

  const onCollectorDetailsChange = (updatedDetail) => {
    let udate = Object.assign({}, updatedCollecorDetails, updatedDetail);
    setUpdatedCollectorDetails(udate);
  };

  const handleSaveAndNext = () => {
    // save the details
    dispatch(setCurrentAgentPersonDetails(updatedCollecorDetails));

    // send it to server
    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        //agentApplication
        if (!isModal) {
          if (agentApplication.businessLicenceData.licenceUpgradeApplicationId) {
            dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_UPLOAD_CERTIFICATE_EDUCATION}`));
          } else {
            dispatch(
              push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_PREVIOUSLY_LICENCED_MORTGAGE_BROKER}`)
            );
          }
        } else {
          dispatch(onEditSave());
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
          <div className="row bottomMarginMedium">
            <div className="col-lg-8">
              <Header
                id="collector-details-header"
                header="Applicant Information"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8">
              <Paragraph
                id="collector-details-text"
                text={["Provide information about the applicant"]}
              />
            </div>
          </div>
        </>
      )}

      <div className="row">
        <div className="col-lg-8">
          <AgentContactDetailsInputForm
            id={"collector-details-form"}
            withAddress={true}
            onInputChange={onCollectorDetailsChange}
            showValidationError={showValidationError}
            preloadInput={updatedCollecorDetails}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8">
          <Button
            id="collection-details-save-next-button"
            buttonType={"regular_primary"}
            text={!isModal ? "Save and next" : "Save and close"}
            onClick={() => {
              if (!validateData()) {
                setShowValidationError(true);
                return;
              }
              setShowValidationError(false);
              // dispatch(setCollectorDetails(updatedCollecorDetails))
              dispatch(setCurrentAgentPersonDetails(updatedCollecorDetails));
              //dispatch(push(replaceUrlParams(collectorDetails.navigation.next,applicationType, applicationMode)))
              handleSaveAndNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};
